import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES, destinations } from "../lib/data";

export default function Destinations() {
  const { t, lang } = useLang();
  return (
    <>
      <PageHero tag={t("destinations.tag")} title={t("destinations.title")} subtitle={t("destinations.subtitle")} image={IMAGES.amalfi} />

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <div className="grid gap-6 md:grid-cols-2">
          {destinations.map((d, i) => (
            <Reveal key={d.key} delay={(i % 2) * 0.1} data-testid={`destination-card-${d.key}`}
              className={`group relative overflow-hidden ${i === 0 || i === 3 ? "md:col-span-2 h-[420px]" : "h-96"}`}>
              <img src={d.image} alt={d[lang].name} className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute bottom-0 max-w-lg p-8 lg:p-10">
                <h3 className="font-heading text-3xl text-white lg:text-4xl">{d[lang].name}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-white/65">{d[lang].desc}</p>
                <Link to="/booking" className="mt-5 inline-flex items-center gap-2 font-body text-xs uppercase tracking-[0.2em] text-gold">
                  {t("common.discover")} <ArrowRight size={14} />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
